<template>
    <div class="qrcode-dom">
        <img :src="imgUrl" :alt="url" :title="url">
    </div>
</template>

<script setup>
    import {onMounted, ref, watch} from "vue";
    import QRCode from 'qrcode'

    const props = defineProps(['url', 'width', 'height'])

    const width = ref(150)
    const height = ref(150)

    const imgUrl = ref(null)

    watch(() => props.url, (newValue, oldValue) => {
        generateQRCode()
    });

    function generateQRCode() {
        QRCode.toDataURL(
            props.url,
            {
                errorCorrectionLevel: 'H' ,
                width: width.value,
                height: height.value,
                margin: 0,
                color: {
                    dark: "#000000",
                    light: "#ffffff"
                }
            },
            function (err, url) {
                imgUrl.value = url
            }
        )
    }

    onMounted(() => {
        if (null != props.width){
            width.value = props.width
        }

        if (null != props.height){
            height.value = props.height
        }

        generateQRCode()
    })

</script>

<style scoped>
    .qrcode-dom {
        display: inline-block;
    }
</style>